import React, { Component } from "react";
import { useSelector } from "react-redux";
import styled from "@emotion/styled";
import BusinessType from "../../artisans/BusinessType"
import { artisansSelector, artisansIsLoadingSelector } from "../../../../modules/reports/artisans/Selectors";
import Spinner from "../../../../components/UI/Misc/Spinner"
import { Link } from "react-router-dom";
import getLangData from "../../../../utils/getLangData";


const Content = () => {
  const { artisans, isLoading } = useSelector((state) => ({
    artisans: artisansSelector(state),
    isLoading: artisansIsLoadingSelector(state)
  }));

  const lang = getLangData().general_words
  return (
    <CardContainer>
      <Header>
        <div className='font-weight-bold'>{lang.business_name}</div>
        <div className='font-weight-bold'>{lang.busience_type}</div>
        <div className='font-weight-bold'>{lang.registered_company}</div>
        <div className='font-weight-bold'>{lang.website}</div>
        <div className='font-weight-bold'>{lang.online_store}</div>
        <div className='font-weight-bold'>{lang.offline_store}</div>
      </Header>
      {isLoading && <SpinnerContainer><Spinner /></SpinnerContainer>}
      {!isLoading && (!artisans || artisans.length === 0) && (
        <div className='kt-widget31__item'>
          <NoItems className='kt-widget31__text'>{lang.no_items}.</NoItems>
        </div>
      )}
      {artisans.map((user) => (
        <Card key={user._id}>
          {console.log(user)}
          <div>
            <Link to={`reports/artisans/${user._id}`}>{user.businessName}</Link>
          </div>
          <div>{user.businessType && <BusinessType businessType={user.businessType} />}</div>
          <div>{user.regCompany ? lang.yes : lang.No}</div>
          <div>
            <span className='font-weight-bold'>
              {user.website}
            </span>
          </div>
          <div>
            <span className='font-weight-bold'>
              {user.onlineStore ? lang.yes : lang.No}
            </span>
          </div>
          <div>
            <span className='font-weight-bold'>
              {user.offlineStore ? lang.yes : lang.No}
            </span>
          </div>
        </Card>
      ))}
    </CardContainer>
  );
};

class ReportsContent extends Component {
  render() {
    return <Content />;
  }
}

export default ReportsContent;

const Card = styled.div`
  background-color: #fff;
  display: inline-grid;
  text-align: center;
  padding: 14px 0px;
  border-bottom: 1px solid #ccc;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
`;

const Header = styled.div`
background-color: #fff;
display: inline-grid;
text-align: center;
padding: 14px 0px;
border: 1px solid #000;
grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;

`

const CardContainer = styled.div`
background-color: #fff;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 50px;
  grid-gap: 3px 3px;
  margin:2px;
`;

const NoItems = styled.p`
  margin: 0;
  font-size: 18px;
  text-align: center;
  width: 100%;
  font-weight: bold;
  opacity: 0.5;
`;

const SpinnerContainer = styled.div`
width: 100%;
height: 100%;
position: absolute;
background-color: rgba(255,255,255,0.5);
display: flex;
justify-content: center;`
